<p-multiSelect 
    [options]="list" 
    [(ngModel)]="selectedItem" 
    defaultLabel="Selecione a Situação" 
    optionLabel="text"
    (onChange)="onChange($event)"
    selectedItemsLabel="{0} Item(ns) Selecionado(s)"
    [style]="{'width':'100%'}"
    [panelStyle]="{'max-width': '100%'}">
</p-multiSelect>